module.exports = __webpack_public_path__ + "img/22.problem_blockage.b7d3681c.svg";